import { GenericService } from "./Generic.service";

export class UnitService extends GenericService<string>{

    readonly URI: string = 'UnidadeAtendimento'

    constructor(){
        super()
        this.setUri(this.URI);
        
    }

    public async registerUnit(unit: any){
        return await super.post(unit)
    }

    public async editUnit(unit: any, unitId: string){
        return await super.putByResource(unit, unitId)
    }

    public async getUnits(){
        return await super.getByResource('', { PageSize: 500 })
    }

    public async getUnit(text: string){
        return await super.getByResource('', {PageSize: 500, text: text})
    }

    public async getUnitById(id: string){
        return await super.getByResource(`${id}`, {PageSize: 500 })
    }

    public async activateUnit(unitId: string){
        return await super.postByResource(unitId, `${unitId}/Activate`)
    }

    public async inactivateUnit(unitId: string){
        return await super.patchByResource(unitId, `${unitId}/Inactivate`)
    }
}